export const etapaProcessoOptions = [
    {
        value: 'NAO_APLICADO',
        label: 'N/A'
    },
    {
        value: 'CONTRATO',
        label: 'Contrato'
    },
    {
        value: 'FATURAMENTO',
        label: 'Faturamento'
    },
    {
        value: 'PRESTACAO_DE_SERVICOS',
        label: 'Prestação de Serviços'
    },
    {
        value: 'PROPOSTA',
        label: 'Proposta'
    },
    {
        value: 'RECEBIMENTO',
        label: 'Recebimento'
    },
];
